var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReserveMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 29,
    viewBox: "0 0 18 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00049 26.2974V3.74972L1.55043 3.19978L11.4494 1L16.124 2.9248V26.8474L12.2743 27.9473L1.8254 26.8474L1.00049 26.2974Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00103 3.74972L1.00104 26.0225C1.00104 26.0225 0.946577 26.92 1.92115 26.92L11.4605 27.9999C11.4605 27.9999 12.3204 28.0337 12.2459 27.0685V1.50125C12.2459 1.50125 12.1284 1 10.9188 1L1.64596 3.24847C1.64596 3.24847 1.00103 3.24847 1.00103 3.74972Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.57049L12.1111 5.71863",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9988 1.27509L16.1234 2.92492V27.1225L11.7239 27.9474",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5.93848 8.92542C5.93848 8.62636 6.15285 8.37031 6.44725 8.31774C6.82561 8.25018 7.17305 8.54108 7.17305 8.92542V10.5373C7.17305 10.9216 6.82561 11.2125 6.44725 11.145C6.15285 11.0924 5.93848 10.8364 5.93848 10.5373V8.92542Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserveMode);
export default __webpack_public_path__ + "static/media/reserve-mode.65e88daf7b101cfdaad9b565a878bf12.svg";
export { ForwardRef as ReactComponent };